import { createAction, handleActions } from 'redux-actions'
import client from 'common/util/http'
import { loadStart, loadFinish, loadError } from 'common/redux/root'

const RESET = 'inquiry_modal/RESET'
const LOAD = 'inquiry_modal/LOAD'

const load = createAction(LOAD)
const reset = createAction(RESET)

const defaultErrorHandler = dispatch => error => {
  dispatch(loadError(error))
  return Promise.reject(error)
}

const defaultLoadHandler = dispatch => response => {
  dispatch(load(response))
  dispatch(loadFinish())
  return Promise.resolve(response)
}

export function resetLeadInquiry(arrived_at, name, email, phone, source, source_type, source_key, logo_url, stage,
                                 resolution, is_duplicate, market, zipcode, price_category, likelihood_category,
                                 client_category, agent_name, agent_email, agent_phone, broker, network_referral, hide_contact_details,
                                 transactions, pending_close_transactions, paid_close_transactions, released_transactions,
                                 release_agent_name, lead_inquiry_hash, primary_lead_inquiry_hash, primary_lead_inquiry_arrived_at) {
  return dispatch => {
    dispatch(reset())
    dispatch(load({
      arrived_at,
      name,
      email,
      phone,
      source,
      source_type,
      source_key,
      logo_url,
      stage,
      resolution,
      is_duplicate,
      market,
      zipcode,
      price_category,
      likelihood_category,
      client_category,
      agent_name,
      agent_email,
      agent_phone,
      broker,
      network_referral,
      hide_contact_details,
      transactions,
      pending_close_transactions,
      paid_close_transactions,
      released_transactions,
      release_agent_name,
      lead_inquiry_hash,
      primary_lead_inquiry_hash,
      primary_lead_inquiry_arrived_at,
    }))
  }
}

export function fetchLeadInquiry(hash) {
  return dispatch => {
    dispatch(loadStart())
    return client.post('lead_inquiry', { data: {
      hash
    }})
      .then(dispatch(defaultLoadHandler))
      .catch(dispatch(defaultErrorHandler))
  }
}

const initialState = {}

export default handleActions({
  [LOAD]: (state, { payload }) => ({ ...state, ...payload }),
  [RESET]: () => ({ ...initialState }),
}, initialState)
